import { toast } from 'react-toastify';
import { validate } from 'validate.js';
import constraints from './validationConstraints';

export const getToken = () => {
  const token = localStorage.getItem('token');
  if (!token) localStorage.removeItem('token');
  return token;
};

export const removeToken = () => {
  localStorage.clear();
};

export const showToast = (type, message = 'Something went wrong!') => {
  const config = {
    position: toast.POSITION.BOTTOM_RIGHT,
    autoClose: 2500,
    hideProgressBar: true,
    pauseOnHover: true,
  };
  switch (type) {
    case 'info':
      toast.info(message, config);
      break;
    case 'warn':
      toast.warn(message, config);
      break;
    case 'success':
      toast.success(message, config);
      break;
    case 'error':
      toast.error(message, config);
      break;
    default:
      toast.info(message, config);
      break;
  }
};

export const handleErrors = (err, message = '') => {
  let flag = 0;
  const msg = { message };
  if (err.response === undefined) flag = 999;
  else flag = err.response.status;
  if (!message) {
    msg.message = err.response.data.message;
  }
  switch (flag) {
    case 400:
      showToast('error', msg.message || 'Something went wrong.');
      break;
    case 401:
      break;
    case 404:
      showToast('error', msg.message || 'Something went wrong.');
      break;
    case 500:
      showToast('error', msg.message || 'Something went wrong.');
      break;
    case 501:
      showToast('error', 'Incorrect query or invalid column value');
      break;
    case 502:
      showToast('error', msg.message || 'Error code 502: Something went wrong.');
      break;
    case 409:
      showToast('error', msg.message || 'Duplicate entry');
      break;
    case 410:
      showToast(
        'error',
        'Unable to delete!',
      );
      break;
    default:
      showToast('error', msg.message || 'Something went wrong.');
      break;
  }
};

export const formValidation = (data, type = 'register') => {
  const localconstraints = { ...constraints }
  switch (type) {
    case 'login':
      delete localconstraints.full_name;
      // delete localconstraints.username;
      delete localconstraints.email;
      delete localconstraints.mobile;
      break;
    case 'resetPassword':
      delete localconstraints.full_name;
      delete localconstraints.username;
      delete localconstraints.mobile;
      delete localconstraints.email;
      break;
    case 'update':
      if (!data.mobile) {
        delete localconstraints.mobile;
      }
      delete localconstraints.password
      break;
    case 'update-vendor':
      if (!data.email) {
        delete localconstraints.email;
      }
      if (!data.mobile) {
        delete localconstraints.mobile;
      }
      delete localconstraints.username;
      delete localconstraints.password
      break;
    case 'monitor':
      delete localconstraints.full_name;
      if (!data.email) {
        delete localconstraints.email;
      }
      if (!data.mobile) {
        delete localconstraints.mobile;
      }
      break;
    case 'supplier':
      localconstraints.password = {
        presence: {
          allowEmpty: false,
          message: '^Please enter password',
        },
        length: {
          minimum: 6,
          message: 'must be at least 6 characters',
        },
        type: 'string',
      }
      break;
    default:
      delete localconstraints.password
      break;
  }

  const validResult = validate(data, localconstraints);
  return validResult
}
